module.exports = __webpack_public_path__ + "img/menu_btn.76a41cf7.png";